import { render, staticRenderFns } from "./userLink.vue?vue&type=template&id=53f0bc90&scoped=true"
import script from "./userLink.vue?vue&type=script&lang=js"
export * from "./userLink.vue?vue&type=script&lang=js"
import style0 from "./userLink.vue?vue&type=style&index=0&id=53f0bc90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0bc90",
  null
  
)

export default component.exports